<template>
    <div class="conss">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/mine' }">个人中心</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/mine' }">我的订单</el-breadcrumb-item>
            <el-breadcrumb-item>订单号 {{info.order_no}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="background-color: #fff;margin-top: 16px;box-sizing: border-box;padding: 30px;">
            <div class="aotitle">
                订单状态
            </div>
            <div class="par1">
                <div class="patItem flx alc">
                    <div class="parleft">
                        订单状态:
                    </div>
                    <div class="parright" v-text="info.order_status_text2">

                    </div>
                </div>

                <div class="patItem flx alc" style="margin: 20px 0;">
                    <div class="parleft">
                        订单编号:
                    </div>
                    <div class="parright" v-text="info.order_no">

                    </div>
                </div>

                <div class="patItem flx alc">
                    <div class="parleft">
                        创建时间:
                    </div>
                    <div class="parright" v-text="info.createtime_text">

                    </div>
                </div>
            </div>
            <div class="aotitle">
                商品信息
            </div>
            <div class="par2 flx alc">
                <div class="parimg">
                    <img :src="$img(info.avatar)" alt="" />
                </div>
                <div class="parinfo">
                    <div class="parname" v-text="info.name">

                    </div>
                </div>
            </div>

            <div class="prices">
                <div class="priceItem flx alc">
                    <div class="pricename" v-text="info.order_status == 0?'需付款':'已付款'"></div>
                    <div class="priceVal" style="font-weight: bold;font-size: 18px;" v-text="`￥${info.total_price}`">

                    </div>
                </div>
            </div>
            <div class="btns flx alc">
                <el-button @click="repays" v-if="info.order_status == 0" type="primary">马上支付</el-button>
                <el-button @click="cancelOrder" v-if="info.order_status == 0">取消订单</el-button>
                <el-button @click="ask" type="primary">咨询客服</el-button>
                <div class="tps">咨询客服，了解课程信息</div>
            </div>
        </div>
        <wechatpay @rfh="getDetail" v-if="showALert" @close="showALert=false" :type="'cer'" :source="'repay'"
            :orderNo="info.order_no" :codeUrl="pay_code_url"></wechatpay>
    </div>
</template>

<script>
    import {
        zorderdetail,
        cancelzorder,
        repayzorder
    } from "@/api/index.js"
    import wechatpay from "@/components/wechatpay.vue"
    export default {
        name: 'OrderDetail',
        components: {
            wechatpay
        },
        data() {
            return {
                info: {},
                showALert: false,
                pay_code_url: ""
            }
        },
        mounted() {
            this.getDetail()
        },
        methods: {
            ask() {
                let that = this
                ysf('product', {
                    show: 1, // 1为打开， 其他参数为隐藏（包括非零元素）
                    title: '订单号:'+that.info.order_no,
                    picture: that.$img(that.info.avatar),
                    note: '商品名称:'+that.info.name,
                    url: '跳转链接',
                    success: function() { // 成功回调
                        ysf('open');
                    },
                    error: function(err) { // 错误回调
                        // handle error
                    }
                })

            },
            repays() {
                let that = this
                let data = that.$route.query.id
                repayzorder(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.pay_code_url = res.data.code_url
                        that.info.order_no = res.data.order_no
                        that.showALert = true
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            cancelOrder(e) {
                let that = this
                let data = that.$route.query.id
                that.$confirm('确定要取消该订单吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cancelzorder(data).then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getDetail()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });

            },
            getDetail() {
                let that = this
                let data = {}
                data.order_id = that.$route.query.id
                zorderdetail(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.info = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .pricename {
        font-size: 14px;
        color: #666666;

    }

    .priceVal {
        width: 93px;
        font-size: 14px;
        color: #FF0F23;
        line-height: 21px;
        text-align: right;
    }

    .priceItem {
        justify-content: flex-end;
        margin-top: 30px;
    }
    .tps{
        font-size: 14px;
        color: red;
        margin-left: 10px;
    }
    .parite {
        display: flex;
        align-items: center;
        margin-bottom: 36px;
    }

    .prtleft {
        width: 385px;
        text-align: right;
        margin-right: 16px;
        font-size: 14px;
        color: #48576A;

    }

    .prtright {
        font-size: 14px;
        color: #141933;
    }

    .prtright img {
        width: 516px;
        height: 252px;
        border-radius: 4px 4px 4px 4px;
        object-fit: cover;
    }

    .infItem {
        font-size: 14px;
        color: #1F2937;
        margin-top: 12px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .parname {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #141933;
    }

    .parimg {
        width: 172px;
        height: 97px;
        margin-right: 16px;
    }

    .parimg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;

    }

    .par2 {
        box-sizing: border-box;
        padding: 30px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 50px;
    }

    .parleft {
        font-size: 14px;
        color: #48576A;
        margin-right: 20px;
    }

    .parright {
        font-weight: 600;
        font-size: 14px;
        color: #141933;
    }

    .par1 {
        width: 100%;
        box-sizing: border-box;
        padding: 30px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 50px;
    }

    .aotitle {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-bottom: 22px;
    }

    .conss {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px 0;
        text-align: left;
    }
</style>